import React, { useContext, useState, useEffect, createContext } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider, keyframes } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import compact from 'lodash/compact';
import { Equalizer } from 'styled-icons/material/Equalizer';
import { Close } from 'styled-icons/material/Close';
import { Home } from 'styled-icons/material/Home';
import { Image } from 'styled-icons/material/Image';
import { Check } from 'styled-icons/material/Check';
import { Warning } from 'styled-icons/material/Warning';
import { Info } from 'styled-icons/material/Info';
import { AddCircleOutline } from 'styled-icons/material/AddCircleOutline';
import { CheckCircle } from 'styled-icons/material/CheckCircle';
import { AccountCircle } from 'styled-icons/material/AccountCircle';
import { Box } from 'styled-icons/fa-solid/Box/Box';
import { Settings } from 'styled-icons/material/Settings';
import { Heart } from 'styled-icons/octicons/Heart';
import { Apps } from 'styled-icons/material/Apps';
import { StoreAlt } from 'styled-icons/boxicons-solid/StoreAlt';
import { ChartPie } from 'styled-icons/fa-solid/ChartPie';
import { Search } from 'styled-icons/material/Search';
import { gql, useQuery, HttpLink } from '@apollo/client';
import get from 'lodash/get';
import { createBreakpoints } from '@mui/system';
import jwt_decode from 'jwt-decode';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { RestLink } from 'apollo-link-rest';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

// Order Fulfillment
var ORDER_FULFILLMENT_ADMIN = 'Order-Fulfillment-Admin';
var PRODUCT_MANAGER_ADMIN = 'Product-Manager-Admin';

var img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 76.3 46.45'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:%23127dc2%3b%7d.cls-2%7bfill:%237f7f7f%3b%7d%3c/style%3e%3c/defs%3e%3ctitle%3eAsset 2%3c/title%3e%3cg id='Layer_2' data-name='Layer 2'%3e%3cg id='Layer_1-2' data-name='Layer 1'%3e%3cpath class='cls-1' d='M9.18%2c11.59c0-3.71%2c1.51-5.46%2c4.7-5.46s4.72%2c1.75%2c4.72%2c5.46v3.69c0%2c3.64-1.52%2c5.39-4.72%2c5.39s-4.7-1.75-4.7-5.39V11.59ZM31.55.75c-4.2-.15-6.31%2c1.07-7.32%2c4.1C21.62%2c1.82%2c18.76.6%2c14.05.6%2c5.64.6%2c1.18%2c5.05%2c1.18%2c13.4c0%2c6.26%2c2.1%2c9.83%2c7%2c11.92C3.37%2c26.6%2c1.68%2c27.93%2c1.68%2c30.5c0%2c2%2c1.35%2c3.23%2c4.88%2c4.37C1.94%2c36.16%2c0%2c37.77%2c0%2c40.39c0%2c4%2c4.8%2c6.06%2c14.47%2c6.06%2c11.36%2c0%2c16.67-2.63%2c16.67-8.34a7%2c7%2c0%2c0%2c0-4-6.46c-2.35-1.15-4.63-1.55-9.93-1.82-3.62-.14-4.29-.2-5.64-.34-1.6-.13-2.43-.68-2.43-1.56S9.84%2c26.45%2c11%2c26a27.12%2c27.12%2c0%2c0%2c0%2c3%2c.2c8.25%2c0%2c12.62-4.44%2c12.62-12.92a15.27%2c15.27%2c0%2c0%2c0-.84-5.45%2c3.83%2c3.83%2c0%2c0%2c1%2c3.11-1.29%2c3.93%2c3.93%2c0%2c0%2c1%2c2.69.88V.75ZM10.09%2c35.42c1.95.19%2c3%2c.26%2c4.13.33%2c4.29.13%2c5%2c.13%2c6.06.27%2c2.36.27%2c3.37%2c1%2c3.37%2c2.29%2c0%2c1.95-2.53%2c2.82-8%2c2.82S8%2c40.39%2c8%2c38.37c0-.93.75-2%2c2.09-2.95Z'/%3e%3cpath class='cls-2' d='M36%2c45.25l7.31-18.84-.13-.13a2.39%2c2.39%2c0%2c0%2c1-1%2c.41%2c7.45%2c7.45%2c0%2c0%2c1-1.74.16A6.28%2c6.28%2c0%2c0%2c1%2c37.35%2c26%2c6.53%2c6.53%2c0%2c0%2c1%2c35.08%2c24a5.62%2c5.62%2c0%2c0%2c1-.69-1.36A8.9%2c8.9%2c0%2c0%2c1%2c34%2c20.74a24.15%2c24.15%2c0%2c0%2c1-.25-2.87q-.06-1.74-.06-4.38%2c0-2.2.06-3.63A18.29%2c18.29%2c0%2c0%2c1%2c34%2c7.44a6.89%2c6.89%2c0%2c0%2c1%2c.41-1.64%2c10.94%2c10.94%2c0%2c0%2c1%2c.73-1.45%2c8.69%2c8.69%2c0%2c0%2c1%2c3.37-3.22A10%2c10%2c0%2c0%2c1%2c43.28%2c0%2c9.44%2c9.44%2c0%2c0%2c1%2c48%2c1.17a9%2c9%2c0%2c0%2c1%2c3.34%2c3.18A14.6%2c14.6%2c0%2c0%2c1%2c52.1%2c5.8a7.75%2c7.75%2c0%2c0%2c1%2c.51%2c1.64c.08.67.14%2c1.48.18%2c2.42s.07%2c2.16.07%2c3.63%2c0%2c2.53-.07%2c3.43-.1%2c1.67-.18%2c2.3-.27%2c1.27-.41%2c1.8-.33%2c1.08-.54%2c1.67L43.21%2c45.25ZM40.13%2c18a3%2c3%2c0%2c0%2c0%2c.94%2c2.33%2c3.18%2c3.18%2c0%2c0%2c0%2c4.41%2c0%2c3%2c3%2c0%2c0%2c0%2c1-2.33V9.64a3.05%2c3.05%2c0%2c0%2c0-1-2.33%2c3.2%2c3.2%2c0%2c0%2c0-4.41%2c0%2c3%2c3%2c0%2c0%2c0-.94%2c2.33Z'/%3e%3cpath class='cls-2' d='M57.14%2c9.64a9.73%2c9.73%2c0%2c0%2c1%2c.79-4%2c9.53%2c9.53%2c0%2c0%2c1%2c2.11-3A9%2c9%2c0%2c0%2c1%2c63.1.66a10.29%2c10.29%2c0%2c0%2c1%2c7.25%2c0A9.07%2c9.07%2c0%2c0%2c1%2c73.4%2c2.58a9.22%2c9.22%2c0%2c0%2c1%2c2.11%2c3%2c9.73%2c9.73%2c0%2c0%2c1%2c.79%2c4V36a9.69%2c9.69%2c0%2c0%2c1-.79%2c4%2c9.22%2c9.22%2c0%2c0%2c1-2.11%2c3A9.07%2c9.07%2c0%2c0%2c1%2c70.35%2c45a10.29%2c10.29%2c0%2c0%2c1-7.25%2c0A9%2c9%2c0%2c0%2c1%2c60%2c43.05a9.53%2c9.53%2c0%2c0%2c1-2.11-3%2c9.69%2c9.69%2c0%2c0%2c1-.79-4ZM63.57%2c36a3.18%2c3.18%2c0%2c0%2c0%2c.88%2c2.3%2c3.29%2c3.29%2c0%2c0%2c0%2c4.54%2c0%2c3.18%2c3.18%2c0%2c0%2c0%2c.88-2.3V9.64A3.18%2c3.18%2c0%2c0%2c0%2c69%2c7.34a3.29%2c3.29%2c0%2c0%2c0-4.54%2c0%2c3.18%2c3.18%2c0%2c0%2c0-.88%2c2.3Z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var _templateObject$k;
var StyledGWLogo = styled.img(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n    display: inline-flex;\n    padding: 0px 10px 0px 0px;\n    align-items: center;\n    justify-content: center;\n    height: 26px;\n"])));
var GWLogo = function GWLogo() {
  return /*#__PURE__*/React.createElement(StyledGWLogo, {
    src: img$1
  });
};

var _templateObject$j;
var StyledMenuLabel = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n    display:flex;\n    flex: 1;\n    background-color: ", ";\n    color: white;\n    padding: 5px 10px;\n    text-align: left;\n    font-size: 16;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.chinchilla;
});
var MenuHeaderLabel = function MenuHeaderLabel() {
  return /*#__PURE__*/React.createElement(StyledMenuLabel, null, "APP SUITE");
};

var _templateObject$i;
var StyledMenuHeader = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    flex:1;\n    justify-content: space-between;\n    margin: 20px;\n    align-items: center;\n"])));
var MenuHeader = function MenuHeader() {
  return /*#__PURE__*/React.createElement(StyledMenuHeader, null, /*#__PURE__*/React.createElement(GWLogo, null), /*#__PURE__*/React.createElement(MenuHeaderLabel, null));
};

var _excluded = ["icon", "color"];
var GWIcon = function GWIcon(_ref) {
  var icon = _ref.icon,
    fill = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  switch (icon) {
    case 'apps':
      return /*#__PURE__*/React.createElement(Apps, _extends({
        fill: fill
      }, rest));
    case 'account-circle':
      return /*#__PURE__*/React.createElement(AccountCircle, _extends({
        fill: fill
      }, rest));
    case 'box':
      return /*#__PURE__*/React.createElement(Box, _extends({
        fill: fill,
        viewBox: "-68 -55 640 640"
      }, rest));
    case 'data':
      return /*#__PURE__*/React.createElement(ChartPie, _extends({
        fill: fill,
        viewBox: "-10 -10 560 560"
      }, rest));
    case 'equalizer':
      return /*#__PURE__*/React.createElement(Equalizer, _extends({
        fill: fill
      }, rest));
    case 'home':
      return /*#__PURE__*/React.createElement(Home, _extends({
        fill: fill
      }, rest));
    case 'settings':
      return /*#__PURE__*/React.createElement(Settings, _extends({
        fill: fill
      }, rest));
    case 'add-circle':
      return /*#__PURE__*/React.createElement(AddCircleOutline, _extends({
        fill: fill
      }, rest));
    case 'close':
      return /*#__PURE__*/React.createElement(Close, _extends({
        fill: fill
      }, rest));
    case 'check-circle':
      return /*#__PURE__*/React.createElement(CheckCircle, _extends({
        fill: fill
      }, rest));
    case 'image':
      return /*#__PURE__*/React.createElement(Image, _extends({
        fill: fill
      }, rest));
    case 'check':
      return /*#__PURE__*/React.createElement(Check, _extends({
        fill: fill
      }, rest));
    case 'info':
      return /*#__PURE__*/React.createElement(Info, _extends({
        fill: fill
      }, rest));
    case 'error':
      return /*#__PURE__*/React.createElement(Warning, _extends({
        fill: fill
      }, rest));
    case 'heart':
      return /*#__PURE__*/React.createElement(Heart, _extends({
        fill: fill
      }, rest));
    case 'store':
      return /*#__PURE__*/React.createElement(StoreAlt, _extends({
        fill: fill
      }, rest));
    case 'search':
      return /*#__PURE__*/React.createElement(Search, _extends({
        fill: fill
      }, rest));
    default:
      return /*#__PURE__*/React.createElement(Warning, _extends({
        fill: fill
      }, rest));
  }
};

var _templateObject$h;
var StyledIcon = styled(GWIcon)(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n    height: 50px;\n    line-height: 0;\n    padding-right: 10px;\n    transition: all 200ms ease-in-out 0s;\n    color: ", ";\n    fill: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.bluemine;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.bluemine;
});
var Icon = function Icon(_ref3) {
  var icon = _ref3.icon;
  return /*#__PURE__*/React.createElement(StyledIcon, {
    icon: icon
  });
};
Icon.propTypes = {
  /** Name of the icon */
  icon: PropTypes.string.isRequired
};

var _templateObject$g;
var StyledLabel$1 = styled.label(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n    color: ", ";\n    transition: all 200ms ease-in-out 0s;\n    font-size: 16px;\n    font-weight: 400;\n    margin: 0px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.chinchilla;
});
var Label = function Label(_ref2) {
  var label = _ref2.label;
  return /*#__PURE__*/React.createElement(StyledLabel$1, null, label);
};
Label.propTypes = {
  /** Name of menu label */
  label: PropTypes.string.isRequired
};

var _templateObject$f;
var StyledMenuItem = styled.a(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n    width: 100%;\n    border: none;\n    background-color: white;\n    text-decoration: none;\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 10px 20px;\n    text-transform: uppercase;\n    cursor: pointer;\n    transition: all 200ms ease-in-out 0s;\n    :hover {\n        background-color: rgba(0, 0, 0, 0.1);\n        svg {\n            color: ", ";\n            fill: ", ";\n        }\n        label {\n            color: ", ";\n        }\n    }\n    &>* {\n        cursor: pointer;\n    }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.lochmara;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.lochmara;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.lochmara;
});
var MenuItem = function MenuItem(_ref4) {
  var label = _ref4.label,
    icon = _ref4.icon,
    linkUrl = _ref4.linkUrl,
    closeMenu = _ref4.closeMenu,
    tabWillClose = _ref4.tabWillClose;
  return /*#__PURE__*/React.createElement(StyledMenuItem, {
    onBlur: tabWillClose ? closeMenu : function () {
      return null;
    },
    onClick: closeMenu,
    href: linkUrl
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  }), /*#__PURE__*/React.createElement(Label, {
    label: label
  }));
};
MenuItem.propTypes = {
  /** Name of menu item */
  label: PropTypes.string.isRequired,
  /** Icon name for menu item */
  icon: PropTypes.string.isRequired,
  /** Url for menu item */
  linkUrl: PropTypes.string.isRequired,
  /** Function to close menu */
  closeMenu: PropTypes.func.isRequired
};

var _templateObject$e, _templateObject2$5;
var StyledNavMenu = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n    z-index: 9999;\n    width: 300px;\n    min-height: 30px;\n    background-color: white;\n    position: fixed;\n    right: 0px;\n    top: 70px;\n    box-shadow: 0px 1px 1px #000;\n    ", "\n    transform: translateX(", "px);\n    transition: transform 200ms ease-in-out 0s;\n"])), breakpoint('xs', 'md')(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n        top: 60px;\n    "]))), function (props) {
  return props.isOpen ? '0' : '300';
});
var NavMenu = function NavMenu(_ref) {
  var isOpen = _ref.isOpen,
    closeMenu = _ref.closeMenu;
  var _useContext = useContext(HeaderContext),
    _useContext$user$scop = _useContext.user.scope,
    scope = _useContext$user$scop === void 0 ? [] : _useContext$user$scop;
  var Apps = compact([{
    label: 'gw home',
    linkUrl: '/',
    icon: 'home'
  }, {
    label: 'campaign engine',
    linkUrl: '/campaign-engine',
    icon: 'settings'
  }, {
    label: 'dashboards',
    linkUrl: '/dashboard',
    icon: 'equalizer'
  }, {
    label: 'admin',
    linkUrl: '/admin',
    icon: 'account-circle'
  }, {
    label: 'insights',
    linkUrl: 'https://gw-data.goodwaygroup.com',
    icon: 'info'
  }, {
    label: 'pixel qa',
    linkUrl: '/pixel-qa',
    icon: 'search'
  }, {
    label: 'data capabilities hub',
    linkUrl: '/data-capabilities-hub',
    icon: 'data'
  }, scope.includes(ORDER_FULFILLMENT_ADMIN) ? {
    label: 'order fulfillment',
    linkUrl: '/order-fulfillment',
    icon: 'box'
  } : null, scope.includes(PRODUCT_MANAGER_ADMIN) ? {
    label: 'retail media',
    linkUrl: '/rmn-portal/',
    icon: 'store'
  } : null]);
  return /*#__PURE__*/React.createElement(StyledNavMenu, {
    isOpen: isOpen,
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(MenuHeader, null), Apps.map(function (item, idx) {
    var label = item.label,
      icon = item.icon,
      linkUrl = item.linkUrl;
    var tabWillClose = idx === Apps.length - 1;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: label,
      tabIndex: idx,
      icon: icon,
      label: label,
      linkUrl: linkUrl,
      closeMenu: closeMenu,
      tabWillClose: tabWillClose
    });
  }));
};
NavMenu.propTypes = {
  /** Flag for managing display state */
  isOpen: PropTypes.bool.isRequired,
  /** Function to close menu */
  closeMenu: PropTypes.func.isRequired
};

var _templateObject$d;
var StyledHeader = styled.header(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n    display:flex;\n    flex: 1;\n    background-color: ", ";\n    color: white;\n    padding: 5px 10px;\n    margin: 20px 20px 0px 20px;\n    text-align: left;\n    text-transform: uppercase;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.chinchilla;
});
var ProfileHeaderLabel = function ProfileHeaderLabel() {
  return /*#__PURE__*/React.createElement(StyledHeader, null, "logged in as");
};

var _templateObject$c;
var StyledLabel = styled.label(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n    color: ", ";\n    padding: 10px;\n    margin-left: 20px;\n    font-weight: 400;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.lochmara;
});
var ProfileEmail = function ProfileEmail() {
  var _useContext = useContext(HeaderContext),
    email = _useContext.user.email;
  return /*#__PURE__*/React.createElement(StyledLabel, null, email);
};

var _templateObject$b;
var StyledSignOutButton = styled.button(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n    display: inline-block;\n    text-transform: uppercase;\n    border-radius: 2px;\n    text-align: center;\n    font-size: 14px;\n    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.30);\n    border-radius: 2px;\n    border: 0px;\n    text-transform: uppercase;\n    cursor: pointer;\n\n    &[disabled] {\n        opacity: 0.5;\n        cursor: default;\n    };\n\n    &:focus {outline:0;};\n\n    &:hover {\n        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.40);\n    }\n\n    min-width: 120px;\n    margin: 0px 20px 20px 20px;\n    padding: 10px;\n    color: white;\n    background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.lochmara;
});
var SignOutButton = function SignOutButton() {
  var _useContext = useContext(HeaderContext),
    doLogout = _useContext.doLogout;
  return /*#__PURE__*/React.createElement(StyledSignOutButton, {
    onClick: doLogout
  }, "sign out");
};

var _templateObject$a, _templateObject2$4;
var StyledProfileMenu = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n    z-index: 10000;\n    width: 300px;\n    min-height: 30px;\n    background-color: white;\n    position: fixed;\n    right: 0px;\n    top: 70px;\n    box-shadow: 0px 1px 1px #000;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    ", "\n    transform: translateX(", "px);\n    transition: transform 200ms ease-in-out 0s;\n\n    :focus {\n        outline: none !important;\n    }\n"])), breakpoint('xs', 'md')(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n        top: 60px;\n    "]))), function (props) {
  return props.isOpen ? '0' : '300';
});
var ProfileMenu = function ProfileMenu(_ref) {
  var isOpen = _ref.isOpen;
  return /*#__PURE__*/React.createElement(StyledProfileMenu, {
    isOpen: isOpen,
    tabIndex: "-4"
  }, /*#__PURE__*/React.createElement(ProfileHeaderLabel, null), /*#__PURE__*/React.createElement(ProfileEmail, null), /*#__PURE__*/React.createElement(SignOutButton, null));
};
ProfileMenu.propTypes = {
  /** Flag for managing open state */
  isOpen: PropTypes.bool.isRequired
};

var _templateObject$9;
var StyledNavButton = styled.label(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n    fill: white;\n    font-size: 30px;\n    height: 40px;\n    line-height: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    background-color: transparent;\n    border-radius: 50%;\n    margin-bottom: 0px;\n    transition: all 200ms ease-in-out 0s;\n    box-sizing: border-box;\n    :hover {\n        color: ", ";\n        fill: ", ";\n    }\n    :focus {\n        outline: none !important;\n    }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.lochmara;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.lochmara;
});
var NavButton = function NavButton(_ref3) {
  var openMenu = _ref3.openMenu;
  return /*#__PURE__*/React.createElement(StyledNavButton, {
    onClick: openMenu,
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(GWIcon, {
    icon: "apps",
    size: 30,
    color: "inherit"
  }));
};
NavButton.propTypes = {
  /** Function for opening nav menu */
  openMenu: PropTypes.func.isRequired
};

var _templateObject$8;
var StyledProfileButton = styled.label(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n    color: white;\n    font-size: 16px;\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    background-color: ", ";\n    border-radius: 50%;\n    border-color: white;\n    border-width: 1px;\n    border-style: solid;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: 200ms ease-in-out 0s;\n    :focus {\n        outline: none !important;\n    }\n    :focus ~ .unified-nav-profile {\n        display: block;\n    }\n    :active {\n        color: white;\n    }\n    :hover {\n        color: ", ";\n        border-color: ", ";\n    }\n"])), function (props) {
  return props.active ? props.theme.chinchilla : props.theme.neutral;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.lochmara;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.lochmara;
});
var ProfileButton = function ProfileButton(_ref3) {
  var openMenu = _ref3.openMenu;
  var _useContext = useContext(HeaderContext),
    fullName = _useContext.user.fullName;
  return /*#__PURE__*/React.createElement(StyledProfileButton, {
    tabIndex: "-2",
    onClick: openMenu
  }, fullName[0]);
};
ProfileButton.propTypes = {
  /** Function to open profile menu */
  openMenu: PropTypes.func.isRequired
};

var _templateObject$7, _templateObject2$3;
var StyledBackground = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n    height: calc(100vh - 70px);\n    width: 100%;\n    position: absolute;\n    top: 70px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 9998;\n    background-color: rgba(0, 0, 0, ", ");\n    transition: background-color 200ms;\n    visibility: ", ";\n    ", "\n"])), function (props) {
  return props.selectedMenu ? '0.3' : '0';
}, function (props) {
  return props.selectedMenu ? 'visible' : 'hidden';
}, breakpoint('xs', 'md')(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n        top: 60px;\n        height: calc(100vh - 60px);\n    "]))));
var Background = function Background(props) {
  var selectedMenu = props.selectedMenu,
    closeMenu = props.closeMenu;
  var handleClose = function handleClose(e) {
    e.stopPropagation();
    closeMenu();
  };
  return /*#__PURE__*/React.createElement(StyledBackground, {
    onClick: handleClose,
    selectedMenu: selectedMenu
  });
};
Background.propTypes = {
  /** Menu currently open */
  selectedMenu: PropTypes.string.isRequired,
  /** Function to close all menus */
  closeMenu: PropTypes.func.isRequired
};

var _templateObject$6, _templateObject2$2;
var StyledLinksWrapper = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n    font-family: Lato, sans-serif;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-size: 16px;\n    height: 70px;\n    flex-wrap: wrap;\n    background: ", ";\n    justify-content: space-around;\n    align-items: center;\n    width: 150px;\n    ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.black;
}, breakpoint('xs', 'md')(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n        font-size: 12px;\n        height: 60px;\n    "]))));
var LinksWrapper = function LinksWrapper() {
  var _useContext = useContext(HeaderContext),
    closer = _useContext.closer;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedMenu = _useState2[0],
    setSelectedMenu = _useState2[1];
  var _openMenu = function openMenu(menu) {
    if (selectedMenu === menu) {
      setSelectedMenu('');
    } else if (selectedMenu) {
      setSelectedMenu('Transition');
      setTimeout(function () {
        return setSelectedMenu(menu);
      }, 100);
    } else {
      setSelectedMenu(menu);
    }
  };
  var closeMenu = function closeMenu() {
    return setSelectedMenu('');
  };
  useEffect(function () {
    if (!closer) return;
    closer.current.addEventListener('click', closeMenu);
    return function () {
      return closer.current.addEventListener('click', closeMenu);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledLinksWrapper, null, /*#__PURE__*/React.createElement(NavButton, {
    openMenu: function openMenu() {
      return _openMenu('Nav');
    }
  }), /*#__PURE__*/React.createElement(ProfileButton, {
    setSelectedMenu: setSelectedMenu,
    openMenu: function openMenu() {
      return _openMenu('Profile');
    }
  }), /*#__PURE__*/React.createElement(NavMenu, {
    isOpen: selectedMenu === 'Nav',
    closeMenu: closeMenu
  }), /*#__PURE__*/React.createElement(ProfileMenu, {
    isOpen: selectedMenu === 'Profile'
  }), /*#__PURE__*/React.createElement(Background, {
    selectedMenu: selectedMenu,
    closeMenu: closeMenu
  }));
};

var img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3c!-- Generator: Adobe Illustrator 16.0.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='194.118px' height='53.782px' viewBox='0 0 194.118 53.782' enable-background='new 0 0 194.118 53.782' xml:space='preserve'%3e%3cg%3e %3cdefs%3e %3crect id='SVGID_1_' y='0' width='194.118' height='53.782'/%3e %3c/defs%3e %3cclipPath id='SVGID_2_'%3e %3cuse xlink:href='%23SVGID_1_' overflow='visible'/%3e %3c/clipPath%3e %3cpath clip-path='url(%23SVGID_2_)' fill='white' d='M55.837%2c25.76c0.68%2c0.07%2c1.063%2c0.092%2c1.448%2c0.117 c1.507%2c0.048%2c1.742%2c0.048%2c2.126%2c0.097c0.829%2c0.093%2c1.184%2c0.354%2c1.184%2c0.802c0%2c0.683-0.887%2c0.992-2.809%2c0.992 c-1.92%2c0-2.686-0.261-2.686-0.971C55.1%2c26.472%2c55.363%2c26.091%2c55.837%2c25.76 M63.372%2c13.586c-1.477-0.049-2.216%2c0.379-2.571%2c1.441 c-0.917-1.062-1.92-1.49-3.575-1.49c-2.953%2c0-4.52%2c1.563-4.52%2c4.493c0%2c2.2%2c0.738%2c3.452%2c2.453%2c4.184 c-1.686%2c0.452-2.277%2c0.92-2.277%2c1.82c0%2c0.709%2c0.475%2c1.133%2c1.714%2c1.536c-1.624%2c0.45-2.305%2c1.019-2.305%2c1.937 c0%2c1.417%2c1.684%2c2.129%2c5.083%2c2.129c3.989%2c0%2c5.851-0.924%2c5.851-2.931c0-0.997-0.503-1.82-1.39-2.269 c-0.824-0.402-1.624-0.543-3.486-0.638c-1.27-0.049-1.507-0.07-1.981-0.117c-0.561-0.048-0.854-0.24-0.854-0.547 c0-0.283%2c0.234-0.52%2c0.648-0.685c0.474%2c0.048%2c0.68%2c0.073%2c1.035%2c0.073c2.897%2c0%2c4.432-1.561%2c4.432-4.539 c0-0.801-0.089-1.301-0.296-1.912c0.326-0.334%2c0.62-0.451%2c1.093-0.451c0.386%2c0%2c0.622%2c0.068%2c0.946%2c0.308V13.586z M55.514%2c17.394 c0-1.3%2c0.531-1.916%2c1.652-1.916c1.123%2c0%2c1.656%2c0.616%2c1.656%2c1.916v1.298c0%2c1.278-0.533%2c1.891-1.656%2c1.891 c-1.121%2c0-1.652-0.613-1.652-1.891V17.394z'/%3e %3cpath clip-path='url(%23SVGID_2_)' fill='white' d='M73.448%2c17.771c0-1.844-0.265-2.649-1.153-3.356 c-0.797-0.615-1.949-0.949-3.337-0.949c-1.421%2c0-2.572%2c0.334-3.37%2c0.949c-0.857%2c0.707-1.154%2c1.512-1.154%2c3.356v3.615 c0%2c1.846%2c0.297%2c2.649%2c1.154%2c3.357c0.798%2c0.614%2c1.949%2c0.945%2c3.37%2c0.945c1.388%2c0%2c2.54-0.331%2c3.337-0.945 c0.888-0.708%2c1.153-1.511%2c1.153-3.357V17.771z M67.183%2c17.628c0-1.491%2c0.531-2.152%2c1.743-2.152c1.242%2c0%2c1.773%2c0.639%2c1.773%2c2.152 v3.898c0%2c1.491-0.531%2c2.154-1.773%2c2.154c-1.212%2c0-1.743-0.663-1.743-2.154V17.628z'/%3e %3cpath clip-path='url(%23SVGID_2_)' fill='white' d='M84.529%2c17.771c0-1.844-0.266-2.649-1.154-3.356 c-0.796-0.615-1.95-0.949-3.338-0.949c-1.418%2c0-2.572%2c0.334-3.368%2c0.949c-0.857%2c0.707-1.154%2c1.512-1.154%2c3.356v3.615 c0%2c1.846%2c0.297%2c2.649%2c1.154%2c3.357c0.796%2c0.614%2c1.95%2c0.945%2c3.368%2c0.945c1.388%2c0%2c2.542-0.331%2c3.338-0.945 c0.888-0.708%2c1.154-1.511%2c1.154-3.357V17.771z M78.263%2c17.628c0-1.491%2c0.531-2.152%2c1.743-2.152c1.244%2c0%2c1.775%2c0.639%2c1.775%2c2.152 v3.898c0%2c1.491-0.531%2c2.154-1.775%2c2.154c-1.212%2c0-1.743-0.663-1.743-2.154V17.628z'/%3e %3cpath clip-path='url(%23SVGID_2_)' fill='white' d='M95.548%2c25.453V9.686H92.8v5.177c-1.21-0.923-2.186-1.326-3.25-1.326 c-1.063%2c0-1.89%2c0.428-2.363%2c1.208c-0.444%2c0.802-0.591%2c1.608-0.591%2c3.425v2.814c0%2c1.798%2c0.147%2c2.627%2c0.591%2c3.429 c0.473%2c0.78%2c1.3%2c1.203%2c2.363%2c1.203c1.064%2c0%2c2.04-0.4%2c3.25-1.322v1.159H95.548z M92.8%2c23.091c-0.736%2c0.423-1.298%2c0.59-1.92%2c0.59 c-0.56%2c0-1.062-0.239-1.27-0.616c-0.235-0.4-0.265-0.71-0.265-1.937V18.03c0-1.231%2c0.03-1.538%2c0.265-1.937 c0.208-0.382%2c0.71-0.617%2c1.27-0.617c0.622%2c0%2c1.184%2c0.166%2c1.92%2c0.595V23.091z'/%3e%3c/g%3e%3cpolygon fill='white' points='106.423%2c25.454 104.531%2c18.244 102.669%2c25.454 100.069%2c25.454 96.938%2c13.704 99.745%2c13.704 101.518%2c21.032 103.32%2c13.704 105.83%2c13.704 107.691%2c21.032 109.347%2c13.704 112.125%2c13.704 109.023%2c25.454 '/%3e%3cg%3e %3cdefs%3e %3crect id='SVGID_3_' y='0' width='194.118' height='53.782'/%3e %3c/defs%3e %3cclipPath id='SVGID_4_'%3e %3cuse xlink:href='%23SVGID_3_' overflow='visible'/%3e %3c/clipPath%3e %3cpath clip-path='url(%23SVGID_4_)' fill='white' d='M122.585%2c25.454c-0.263-0.877-0.323-1.419-0.323-3.191v-5.225 c0-1.444-0.179-1.985-0.798-2.601c-0.68-0.615-1.655-0.9-3.016-0.9c-2.953%2c0-4.667%2c1.255-4.903%2c3.618h2.895 c0.12-1.184%2c0.595-1.678%2c1.624-1.678c1.035%2c0%2c1.449%2c0.475%2c1.449%2c1.678v0.616c-2.334%2c0.801-3.103%2c1.088-3.752%2c1.418 c-1.831%2c0.874-2.543%2c1.796-2.543%2c3.308c0%2c1.941%2c1.124%2c3.12%2c2.987%2c3.12c1.182%2c0%2c1.978-0.377%2c3.308-1.534 c0%2c0.563%2c0.091%2c1.04%2c0.237%2c1.371H122.585z M119.513%2c22.614c-0.532%2c0.71-1.239%2c1.066-2.008%2c1.066c-0.799%2c0-1.388-0.546-1.388-1.326 c0-1.084%2c0.974-1.913%2c3.396-2.953V22.614z'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='white' d='M133.639%2c13.705l-3.192%2c11.25c-1.003%2c3.853-2.096%2c4.68-6.234%2c4.68v-2.27 c0.21%2c0.024%2c0.412%2c0.024%2c0.502%2c0.024c1.479%2c0%2c2.483-0.779%2c2.483-1.936c0-0.26-0.059-0.52-0.207-1.016l-3.221-10.733h2.896 l2.158%2c8.011l1.979-8.011H133.639z'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='%23007DC4' d='M142.089%2c25.76c0.68%2c0.07%2c1.065%2c0.092%2c1.447%2c0.117 c1.509%2c0.048%2c1.745%2c0.048%2c2.128%2c0.097c0.829%2c0.093%2c1.183%2c0.354%2c1.183%2c0.802c0%2c0.683-0.886%2c0.992-2.808%2c0.992 c-1.921%2c0-2.689-0.261-2.689-0.971C141.35%2c26.472%2c141.618%2c26.091%2c142.089%2c25.76 M149.625%2c13.586 c-1.479-0.049-2.217%2c0.379-2.573%2c1.441c-0.915-1.062-1.917-1.49-3.574-1.49c-2.956%2c0-4.521%2c1.563-4.521%2c4.493 c0%2c2.2%2c0.74%2c3.452%2c2.454%2c4.184c-1.685%2c0.452-2.275%2c0.92-2.275%2c1.82c0%2c0.709%2c0.473%2c1.133%2c1.712%2c1.536 c-1.624%2c0.45-2.305%2c1.019-2.305%2c1.937c0%2c1.417%2c1.686%2c2.129%2c5.085%2c2.129c3.988%2c0%2c5.852-0.924%2c5.852-2.931 c0-0.997-0.505-1.82-1.393-2.269c-0.826-0.402-1.622-0.543-3.483-0.638c-1.271-0.049-1.51-0.07-1.983-0.117 c-0.56-0.048-0.855-0.24-0.855-0.547c0-0.283%2c0.236-0.52%2c0.651-0.685c0.473%2c0.048%2c0.678%2c0.073%2c1.034%2c0.073 c2.896%2c0%2c4.432-1.561%2c4.432-4.539c0-0.801-0.088-1.301-0.297-1.912c0.326-0.334%2c0.621-0.451%2c1.095-0.451 c0.385%2c0%2c0.619%2c0.068%2c0.946%2c0.308V13.586z M141.764%2c17.394c0-1.3%2c0.532-1.916%2c1.654-1.916c1.123%2c0%2c1.659%2c0.616%2c1.659%2c1.916v1.298 c0%2c1.278-0.536%2c1.891-1.659%2c1.891c-1.122%2c0-1.654-0.613-1.654-1.891V17.394z'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='%23007DC4' d='M153.965%2c13.705v2.032c0.736-1.558%2c1.8-2.2%2c3.514-2.2v2.556 c-0.531-0.165-0.884-0.215-1.326-0.215c-0.739%2c0-1.332%2c0.215-1.715%2c0.615c-0.383%2c0.402-0.473%2c0.784-0.473%2c1.894v7.067h-2.75V13.705 H153.965z'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='%23007DC4' d='M167.882%2c17.771c0-1.844-0.263-2.649-1.151-3.356 c-0.798-0.615-1.951-0.949-3.34-0.949c-1.418%2c0-2.569%2c0.334-3.368%2c0.949c-0.854%2c0.707-1.15%2c1.512-1.15%2c3.356v3.615 c0%2c1.846%2c0.297%2c2.649%2c1.15%2c3.357c0.799%2c0.614%2c1.95%2c0.945%2c3.368%2c0.945c1.389%2c0%2c2.542-0.331%2c3.34-0.945 c0.889-0.708%2c1.151-1.511%2c1.151-3.357V17.771z M161.618%2c17.628c0-1.491%2c0.534-2.152%2c1.743-2.152c1.242%2c0%2c1.774%2c0.639%2c1.774%2c2.152 v3.898c0%2c1.491-0.532%2c2.154-1.774%2c2.154c-1.209%2c0-1.743-0.663-1.743-2.154V17.628z'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='%23007DC4' d='M17.55%2c36.731c1.726%2c0.148%2c2.589%2c0.226%2c7.228%2c0.374 c6.796%2c0.301%2c9.711%2c0.752%2c12.73%2c2.028c1.778%2c0.782%2c3.128%2c1.93%2c3.987%2c3.323V11.344c-0.545-0.156-1.117-0.214-1.827-0.214 c-1.728%2c0-2.807%2c0.375-3.992%2c1.427c0.753%2c1.951%2c1.078%2c3.528%2c1.078%2c6.08c0%2c9.459-5.612%2c14.415-16.184%2c14.415 c-1.294%2c0-2.049-0.073-3.775-0.226c-1.511%2c0.528-2.373%2c1.277-2.373%2c2.177C14.422%2c35.98%2c15.501%2c36.579%2c17.55%2c36.731'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='white' d='M20.484%2c26.896c4.101%2c0%2c6.042-1.952%2c6.042-6.007v-4.128 c0-4.13-1.941-6.082-6.042-6.082c-4.099%2c0-6.04%2c1.952-6.04%2c6.082v4.128C14.444%2c24.944%2c16.385%2c26.896%2c20.484%2c26.896'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='white' d='M24.489%2c46.906c-0.274-3.281-8.325-2.843-14.344-4.477 c-4.161-0.746-5.304-2.32-5.304-4.572c0-2.853%2c2.735-4.829%2c8.308-5.782c-6.258-2.327-8.955-6.306-8.955-13.288 c0-9.309%2c5.717-14.263%2c16.506-14.263c6.042%2c0%2c9.709%2c1.351%2c13.055%2c4.729c0.998-2.605%2c2.837-5.514%2c6.094-5.95 c-0.898-0.975-2.091-1.576-3.404-1.576H7.348c-2.802%2c0-5.073%2c2.712-5.073%2c6.053v42.361C19.689%2c50.141%2c24.337%2c50.188%2c24.489%2c46.906' /%3e %3cpath clip-path='url(%23SVGID_4_)' fill='white' d='M187.33%2c36.38h-0.806v5.956h3.382v-0.678h-2.576V36.38z M181.142%2c37.707 c0.027-0.073%2c0.055-0.157%2c0.086-0.252c0.027-0.097%2c0.059-0.2%2c0.089-0.314c0.058%2c0.224%2c0.116%2c0.412%2c0.178%2c0.562l0.935%2c2.424h-2.223 L181.142%2c37.707z M181.728%2c36.38h-0.82l-2.38%2c5.956h0.623c0.068%2c0%2c0.127-0.02%2c0.174-0.059s0.081-0.084%2c0.101-0.133l0.558-1.438 h2.672l0.556%2c1.438c0.024%2c0.056%2c0.057%2c0.102%2c0.101%2c0.138c0.044%2c0.034%2c0.103%2c0.054%2c0.175%2c0.054h0.624L181.728%2c36.38z M172.582%2c36.38 v0.678h1.933v5.278h0.807v-5.278h1.926V36.38H172.582z M169.93%2c36.38h-0.807v5.956h0.807V36.38z M162.985%2c41.588 c-0.268-0.107-0.498-0.264-0.69-0.47c-0.194-0.205-0.347-0.455-0.452-0.75c-0.105-0.296-0.16-0.633-0.16-1.009 c0-0.359%2c0.052-0.686%2c0.153-0.975c0.104-0.289%2c0.25-0.536%2c0.442-0.739c0.191-0.204%2c0.423-0.36%2c0.694-0.47 c0.271-0.11%2c0.574-0.165%2c0.909-0.165c0.229%2c0%2c0.43%2c0.018%2c0.598%2c0.055c0.167%2c0.036%2c0.312%2c0.08%2c0.436%2c0.131s0.228%2c0.104%2c0.314%2c0.16 c0.085%2c0.056%2c0.163%2c0.102%2c0.233%2c0.141c0.052%2c0.03%2c0.1%2c0.047%2c0.144%2c0.047c0.076%2c0%2c0.138-0.038%2c0.184-0.112l0.228-0.366 c-0.126-0.118-0.263-0.221-0.411-0.314c-0.146-0.092-0.306-0.172-0.479-0.236c-0.174-0.065-0.361-0.115-0.563-0.149 c-0.203-0.035-0.422-0.053-0.658-0.053c-0.464%2c0-0.885%2c0.074-1.261%2c0.221s-0.697%2c0.354-0.96%2c0.621 c-0.265%2c0.268-0.469%2c0.589-0.612%2c0.962c-0.143%2c0.375-0.213%2c0.788-0.213%2c1.243c0%2c0.449%2c0.073%2c0.86%2c0.217%2c1.235 c0.147%2c0.374%2c0.35%2c0.694%2c0.611%2c0.963c0.26%2c0.267%2c0.57%2c0.475%2c0.931%2c0.623c0.359%2c0.148%2c0.756%2c0.222%2c1.189%2c0.222 c0.245%2c0%2c0.473-0.014%2c0.685-0.039c0.211-0.026%2c0.408-0.066%2c0.593-0.121c0.185-0.053%2c0.357-0.12%2c0.52-0.201 c0.162-0.08%2c0.317-0.175%2c0.468-0.282v-2.286h-1.829v0.457c0%2c0.044%2c0.016%2c0.082%2c0.048%2c0.111c0.031%2c0.03%2c0.073%2c0.046%2c0.127%2c0.046 h0.923v1.313c-0.105%2c0.057-0.212%2c0.105-0.316%2c0.148c-0.104%2c0.042-0.218%2c0.08-0.337%2c0.109c-0.118%2c0.03-0.246%2c0.055-0.38%2c0.069 s-0.282%2c0.022-0.444%2c0.022C163.544%2c41.75%2c163.251%2c41.695%2c162.985%2c41.588 M157.951%2c36.38h-0.808v5.956h0.808V36.38z M153.258%2c40.342 c-0.102%2c0.288-0.241%2c0.531-0.425%2c0.729c-0.182%2c0.198-0.403%2c0.351-0.665%2c0.455c-0.261%2c0.106-0.549%2c0.158-0.868%2c0.158h-1.417v-4.651 h1.417c0.319%2c0%2c0.607%2c0.053%2c0.868%2c0.158c0.262%2c0.104%2c0.483%2c0.256%2c0.665%2c0.457c0.184%2c0.199%2c0.323%2c0.442%2c0.425%2c0.731 c0.1%2c0.288%2c0.148%2c0.615%2c0.148%2c0.98C153.406%2c39.726%2c153.357%2c40.052%2c153.258%2c40.342 M154.022%2c38.142 c-0.141-0.366-0.341-0.679-0.598-0.941c-0.258-0.262-0.567-0.466-0.927-0.606c-0.36-0.143-0.761-0.214-1.198-0.214h-2.228v5.956 h2.228c0.438%2c0%2c0.838-0.071%2c1.198-0.214c0.359-0.143%2c0.669-0.345%2c0.927-0.605c0.257-0.26%2c0.457-0.573%2c0.598-0.938 c0.142-0.366%2c0.211-0.771%2c0.211-1.219C154.233%2c38.914%2c154.164%2c38.508%2c154.022%2c38.142 M139.535%2c36.38v0.678h1.932v5.278h0.807 v-5.278h1.925V36.38H139.535z M134.227%2c37.016h0.88c0.464%2c0%2c0.812%2c0.091%2c1.047%2c0.27c0.233%2c0.181%2c0.351%2c0.448%2c0.351%2c0.804 c0%2c0.173-0.03%2c0.332-0.091%2c0.478c-0.062%2c0.145-0.152%2c0.268-0.272%2c0.372c-0.121%2c0.104-0.27%2c0.185-0.448%2c0.24 c-0.179%2c0.057-0.388%2c0.085-0.622%2c0.085h-0.844V37.016z M134.837%2c39.851c0.111%2c0%2c0.194%2c0.015%2c0.25%2c0.044 c0.055%2c0.029%2c0.106%2c0.076%2c0.153%2c0.143l1.548%2c2.128c0.068%2c0.114%2c0.176%2c0.171%2c0.322%2c0.171h0.716l-1.738-2.365 c-0.077-0.111-0.165-0.195-0.266-0.254c0.23-0.052%2c0.436-0.13%2c0.618-0.233c0.182-0.102%2c0.335-0.225%2c0.461-0.371 c0.127-0.145%2c0.224-0.31%2c0.289-0.492c0.067-0.184%2c0.1-0.379%2c0.1-0.591c0-0.253-0.042-0.48-0.129-0.683 c-0.085-0.204-0.218-0.379-0.396-0.522c-0.18-0.145-0.405-0.256-0.68-0.33c-0.275-0.077-0.601-0.114-0.979-0.114h-1.683v5.956 h0.803v-2.485H134.837z M127.958%2c37.707c0.028-0.073%2c0.056-0.157%2c0.086-0.252c0.029-0.097%2c0.059-0.2%2c0.089-0.314 c0.058%2c0.224%2c0.117%2c0.412%2c0.179%2c0.562l0.936%2c2.424h-2.224L127.958%2c37.707z M128.544%2c36.38h-0.819l-2.381%2c5.956h0.623 c0.068%2c0%2c0.127-0.02%2c0.175-0.059c0.047-0.039%2c0.079-0.084%2c0.101-0.133l0.556-1.438h2.673l0.558%2c1.438 c0.022%2c0.056%2c0.056%2c0.102%2c0.101%2c0.138c0.043%2c0.034%2c0.102%2c0.054%2c0.175%2c0.054h0.621L128.544%2c36.38z M119.645%2c40.184l-2.058-3.667 c-0.036-0.063-0.072-0.103-0.111-0.116s-0.096-0.021-0.168-0.021h-0.593v5.956h0.706v-4.377c0-0.059-0.003-0.122-0.007-0.191 c-0.003-0.068-0.01-0.14-0.019-0.211l2.088%2c3.736c0.068%2c0.125%2c0.165%2c0.188%2c0.291%2c0.188h0.116c0.124%2c0%2c0.221-0.062%2c0.29-0.188 l2.041-3.726c-0.005%2c0.07-0.01%2c0.139-0.012%2c0.204c-0.003%2c0.067-0.006%2c0.129-0.006%2c0.188v4.377h0.708V36.38h-0.596 c-0.071%2c0-0.126%2c0.007-0.165%2c0.021s-0.078%2c0.053-0.111%2c0.116l-2.017%2c3.663c-0.04%2c0.071-0.074%2c0.142-0.105%2c0.214 c-0.03%2c0.069-0.059%2c0.144-0.087%2c0.222c-0.027-0.075-0.056-0.149-0.085-0.222C119.717%2c40.319%2c119.684%2c40.25%2c119.645%2c40.184 M113.892%2c36.929c-0.205-0.2-0.444-0.353-0.72-0.458c-0.273-0.105-0.578-0.158-0.909-0.158c-0.297%2c0-0.56%2c0.046-0.788%2c0.139 c-0.229%2c0.091-0.421%2c0.212-0.575%2c0.364c-0.156%2c0.152-0.275%2c0.327-0.356%2c0.524c-0.082%2c0.197-0.123%2c0.4-0.123%2c0.61 c0%2c0.265%2c0.041%2c0.485%2c0.123%2c0.663c0.081%2c0.18%2c0.189%2c0.328%2c0.322%2c0.446c0.134%2c0.12%2c0.285%2c0.216%2c0.457%2c0.293 c0.168%2c0.073%2c0.344%2c0.14%2c0.522%2c0.196c0.179%2c0.058%2c0.354%2c0.112%2c0.522%2c0.167c0.172%2c0.054%2c0.323%2c0.12%2c0.456%2c0.196 c0.134%2c0.079%2c0.241%2c0.175%2c0.322%2c0.29c0.081%2c0.114%2c0.123%2c0.263%2c0.123%2c0.442c0%2c0.164-0.028%2c0.312-0.084%2c0.444 s-0.134%2c0.248-0.239%2c0.343c-0.103%2c0.096-0.23%2c0.171-0.38%2c0.222c-0.149%2c0.054-0.32%2c0.08-0.512%2c0.08c-0.229%2c0-0.423-0.03-0.584-0.094 c-0.159-0.062-0.295-0.131-0.406-0.205c-0.114-0.076-0.206-0.145-0.281-0.206c-0.075-0.062-0.141-0.093-0.198-0.093 c-0.041%2c0-0.075%2c0.01-0.106%2c0.03c-0.032%2c0.021-0.06%2c0.046-0.082%2c0.077l-0.232%2c0.383c0.226%2c0.236%2c0.496%2c0.428%2c0.812%2c0.566 c0.318%2c0.141%2c0.668%2c0.21%2c1.054%2c0.21c0.315%2c0%2c0.598-0.049%2c0.847-0.145c0.247-0.098%2c0.457-0.231%2c0.627-0.4 c0.171-0.169%2c0.3-0.367%2c0.389-0.597c0.088-0.228%2c0.133-0.472%2c0.133-0.734c0-0.246-0.04-0.454-0.123-0.623 c-0.081-0.169-0.188-0.311-0.324-0.427c-0.134-0.117-0.286-0.213-0.457-0.289c-0.171-0.077-0.345-0.145-0.522-0.206 c-0.179-0.062-0.354-0.121-0.525-0.176c-0.169-0.058-0.323-0.124-0.457-0.203c-0.134-0.077-0.243-0.17-0.324-0.28 c-0.081-0.109-0.121-0.246-0.121-0.412c0-0.133%2c0.021-0.252%2c0.069-0.365c0.048-0.111%2c0.117-0.21%2c0.209-0.292 c0.095-0.084%2c0.209-0.149%2c0.349-0.198c0.139-0.048%2c0.298-0.073%2c0.479-0.073c0.191%2c0%2c0.354%2c0.024%2c0.487%2c0.071 c0.134%2c0.048%2c0.25%2c0.099%2c0.345%2c0.155c0.097%2c0.058%2c0.175%2c0.108%2c0.238%2c0.155c0.062%2c0.049%2c0.116%2c0.072%2c0.163%2c0.072 c0.045%2c0%2c0.08-0.011%2c0.106-0.032c0.029-0.021%2c0.056-0.051%2c0.081-0.093L113.892%2c36.929z M105.871%2c36.38h-0.715 c-0.069%2c0-0.125%2c0.02-0.168%2c0.06c-0.042%2c0.041-0.077%2c0.083-0.103%2c0.127l-1.358%2c2.316c-0.056%2c0.094-0.101%2c0.183-0.138%2c0.269 c-0.035%2c0.085-0.068%2c0.173-0.1%2c0.258c-0.03-0.082-0.064-0.168-0.102-0.254c-0.037-0.087-0.084-0.177-0.139-0.272l-1.364-2.316 c-0.03-0.053-0.067-0.096-0.107-0.133c-0.042-0.036-0.1-0.054-0.171-0.054h-0.708l2.185%2c3.587v2.369h0.802v-2.369L105.871%2c36.38z M97.143%2c36.38h-0.807v5.956h3.384v-0.678h-2.577V36.38z M89.162%2c36.38v0.678h1.933v5.278h0.807v-5.278h1.924V36.38H89.162z M86.946%2c36.929c-0.205-0.2-0.444-0.353-0.718-0.458c-0.276-0.105-0.579-0.158-0.911-0.158c-0.297%2c0-0.559%2c0.046-0.787%2c0.139 c-0.229%2c0.091-0.421%2c0.212-0.576%2c0.364c-0.155%2c0.152-0.274%2c0.327-0.357%2c0.524c-0.081%2c0.197-0.121%2c0.4-0.121%2c0.61 c0%2c0.265%2c0.04%2c0.485%2c0.121%2c0.663c0.083%2c0.18%2c0.19%2c0.328%2c0.323%2c0.446c0.133%2c0.12%2c0.285%2c0.216%2c0.456%2c0.293 c0.171%2c0.073%2c0.344%2c0.14%2c0.523%2c0.196c0.178%2c0.058%2c0.353%2c0.112%2c0.524%2c0.167c0.17%2c0.054%2c0.322%2c0.12%2c0.455%2c0.196 c0.133%2c0.079%2c0.24%2c0.175%2c0.321%2c0.29c0.083%2c0.114%2c0.124%2c0.263%2c0.124%2c0.442c0%2c0.164-0.028%2c0.312-0.083%2c0.444 c-0.056%2c0.133-0.135%2c0.248-0.239%2c0.343c-0.105%2c0.096-0.232%2c0.171-0.381%2c0.222c-0.15%2c0.054-0.32%2c0.08-0.51%2c0.08 c-0.231%2c0-0.425-0.03-0.584-0.094c-0.16-0.062-0.297-0.131-0.409-0.205c-0.111-0.076-0.205-0.145-0.28-0.206 c-0.075-0.062-0.142-0.093-0.199-0.093c-0.039%2c0-0.074%2c0.01-0.106%2c0.03c-0.032%2c0.021-0.059%2c0.046-0.081%2c0.077l-0.233%2c0.383 c0.224%2c0.236%2c0.496%2c0.428%2c0.813%2c0.566c0.317%2c0.141%2c0.668%2c0.21%2c1.053%2c0.21c0.316%2c0%2c0.597-0.049%2c0.846-0.145 c0.248-0.098%2c0.457-0.231%2c0.627-0.4c0.171-0.169%2c0.301-0.367%2c0.389-0.597c0.089-0.228%2c0.133-0.472%2c0.133-0.734 c0-0.246-0.041-0.454-0.122-0.623c-0.082-0.169-0.19-0.311-0.324-0.427c-0.136-0.117-0.288-0.213-0.458-0.289 c-0.171-0.077-0.344-0.145-0.523-0.206c-0.179-0.062-0.354-0.121-0.524-0.176c-0.171-0.058-0.323-0.124-0.457-0.203 c-0.135-0.077-0.243-0.17-0.325-0.28c-0.082-0.109-0.123-0.246-0.123-0.412c0-0.133%2c0.024-0.252%2c0.072-0.365 c0.046-0.111%2c0.116-0.21%2c0.21-0.292c0.092-0.084%2c0.208-0.149%2c0.346-0.198c0.139-0.048%2c0.298-0.073%2c0.478-0.073 c0.191%2c0%2c0.353%2c0.024%2c0.489%2c0.071c0.134%2c0.048%2c0.249%2c0.099%2c0.344%2c0.155c0.097%2c0.058%2c0.175%2c0.108%2c0.238%2c0.155 c0.063%2c0.049%2c0.117%2c0.072%2c0.165%2c0.072c0.043%2c0%2c0.079-0.011%2c0.107-0.032c0.028-0.021%2c0.055-0.051%2c0.078-0.093L86.946%2c36.929z M77.206%2c36.38v5.956h3.672v-0.657h-2.861v-2.032h2.316v-0.631h-2.316v-1.979h2.861V36.38H77.206z M69.675%2c36.38h-0.416v5.956 h0.707v-4.244c0-0.055-0.002-0.116-0.004-0.182c-0.003-0.067-0.008-0.136-0.013-0.204l3.446%2c4.484 c0.042%2c0.053%2c0.084%2c0.09%2c0.128%2c0.112c0.041%2c0.021%2c0.096%2c0.033%2c0.159%2c0.033h0.408V36.38h-0.707v4.219 c0%2c0.064%2c0.001%2c0.13%2c0.004%2c0.197s0.008%2c0.138%2c0.017%2c0.209l-3.451-4.488c-0.045-0.055-0.084-0.093-0.119-0.111 C69.801%2c36.388%2c69.746%2c36.38%2c69.675%2c36.38 M65.519%2c40.343c-0.101%2c0.289-0.242%2c0.535-0.425%2c0.736 c-0.183%2c0.199-0.404%2c0.354-0.666%2c0.462c-0.259%2c0.105-0.55%2c0.159-0.872%2c0.159c-0.318%2c0-0.609-0.054-0.869-0.159 c-0.259-0.108-0.482-0.263-0.666-0.462c-0.185-0.201-0.327-0.447-0.426-0.736c-0.101-0.289-0.15-0.617-0.15-0.983 c0-0.365%2c0.049-0.693%2c0.15-0.984c0.099-0.29%2c0.241-0.536%2c0.426-0.737c0.184-0.202%2c0.407-0.357%2c0.666-0.465 c0.26-0.107%2c0.551-0.162%2c0.869-0.162c0.322%2c0%2c0.613%2c0.055%2c0.872%2c0.162c0.262%2c0.107%2c0.483%2c0.263%2c0.666%2c0.465 c0.183%2c0.201%2c0.324%2c0.447%2c0.425%2c0.737c0.099%2c0.291%2c0.149%2c0.619%2c0.149%2c0.984C65.667%2c39.726%2c65.618%2c40.054%2c65.519%2c40.343 M66.283%2c38.132c-0.141-0.373-0.341-0.694-0.598-0.964c-0.258-0.271-0.568-0.481-0.929-0.631c-0.362-0.149-0.762-0.225-1.2-0.225 s-0.836%2c0.075-1.197%2c0.225c-0.361%2c0.149-0.669%2c0.359-0.927%2c0.631c-0.258%2c0.27-0.457%2c0.591-0.598%2c0.964 c-0.142%2c0.372-0.212%2c0.781-0.212%2c1.228c0%2c0.447%2c0.07%2c0.856%2c0.212%2c1.229c0.141%2c0.372%2c0.34%2c0.693%2c0.598%2c0.962 c0.258%2c0.267%2c0.566%2c0.477%2c0.927%2c0.626c0.361%2c0.147%2c0.759%2c0.222%2c1.197%2c0.222s0.838-0.074%2c1.2-0.222 c0.361-0.149%2c0.671-0.359%2c0.929-0.626c0.257-0.269%2c0.457-0.59%2c0.598-0.962c0.142-0.373%2c0.213-0.782%2c0.213-1.229 C66.496%2c38.914%2c66.425%2c38.504%2c66.283%2c38.132 M57.845%2c36.38h-0.811v2.656h-3.209V36.38h-0.81v5.956h0.81v-2.71h3.209v2.71h0.811 V36.38z'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='white' d='M44.218%2c47.896h-0.425v0.543h0.425c0.213%2c0%2c0.339-0.105%2c0.339-0.272 C44.557%2c47.992%2c44.431%2c47.896%2c44.218%2c47.896 M44.494%2c48.667l0.461%2c0.646h-0.389l-0.416-0.591h-0.357v0.591h-0.325v-1.71h0.764 c0.397%2c0%2c0.659%2c0.202%2c0.659%2c0.546C44.891%2c48.429%2c44.728%2c48.601%2c44.494%2c48.667 M44.133%2c47.033c-0.836%2c0-1.469%2c0.665-1.469%2c1.478 s0.629%2c1.469%2c1.459%2c1.469c0.836%2c0%2c1.468-0.666%2c1.468-1.478C45.591%2c47.688%2c44.963%2c47.033%2c44.133%2c47.033 M44.123%2c50.141 c-0.917%2c0-1.631-0.737-1.631-1.631c0-0.895%2c0.723-1.641%2c1.641-1.641c0.917%2c0%2c1.63%2c0.737%2c1.63%2c1.632S45.04%2c50.141%2c44.123%2c50.141'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='%23007DC4' d='M178.848%2c25.454h-2.751v-1.514c-1.27%2c1.184-2.363%2c1.678-3.664%2c1.678 c-1.624%2c0-2.392-0.874-2.392-2.744v-9.17h2.745v8.605c0%2c1.017%2c0.27%2c1.372%2c1.036%2c1.372s1.566-0.424%2c2.274-1.183v-8.794h2.751V25.454 z'/%3e %3cpath clip-path='url(%23SVGID_4_)' fill='%23007DC4' d='M181.121%2c13.705v15.767h2.749v-5.177c1.212%2c0.921%2c2.186%2c1.323%2c3.251%2c1.323 c1.061%2c0%2c1.888-0.423%2c2.36-1.205c0.443-0.802%2c0.593-1.609%2c0.593-3.428v-2.813c0-1.796-0.149-2.625-0.593-3.426 c-0.473-0.781-1.3-1.209-2.36-1.209c-1.065%2c0-2.039%2c0.403-3.251%2c1.327v-1.159H181.121z M183.87%2c16.071 c0.706-0.406%2c1.3-0.594%2c1.92-0.594c0.56%2c0%2c1.062%2c0.234%2c1.271%2c0.616c0.235%2c0.4%2c0.265%2c0.708%2c0.265%2c1.937v3.098 c0%2c1.227-0.029%2c1.538-0.265%2c1.937c-0.208%2c0.377-0.711%2c0.616-1.271%2c0.616c-0.62%2c0-1.182-0.167-1.92-0.59V16.071z'/%3e%3c/g%3e%3c/svg%3e";

var _templateObject$5;
var StyledLogoAnchor = styled.a(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 160px;\n"])));
var LogoAnchor = function LogoAnchor() {
  var _useContext = useContext(HeaderContext),
    logoHrefUrl = _useContext.logoHrefUrl;
  return /*#__PURE__*/React.createElement(StyledLogoAnchor, {
    href: logoHrefUrl
  }, /*#__PURE__*/React.createElement("img", {
    src: img,
    style: {
      width: '140px',
      height: '70px'
    },
    alt: ""
  }));
};

var _templateObject$4;
var StyledLogoWrapper = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 160px;\n"])));
var LogoWrapper = function LogoWrapper() {
  return /*#__PURE__*/React.createElement(StyledLogoWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: img,
    style: {
      width: '140px',
      height: '70px'
    },
    alt: ""
  }));
};

var _templateObject$3, _templateObject2$1;
var StyledFullHeader = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n    display: flex;\n    z-index: ", ";\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100vw;\n    height: 70px;\n    padding: 0 20px;\n    box-sizing: border-box;\n    background: ", ";\n    justify-content: space-between;\n    align-items: center;\n    ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex || 10;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.black;
}, breakpoint('xs', 'md')(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n        font-size: 12px;\n        height: 60px;\n    "]))));
var FullHeader = function FullHeader() {
  var _useContext = useContext(HeaderContext),
    logoHrefUrl = _useContext.logoHrefUrl;
  return /*#__PURE__*/React.createElement(StyledFullHeader, null, logoHrefUrl ? /*#__PURE__*/React.createElement(LogoAnchor, null) : /*#__PURE__*/React.createElement(LogoWrapper, null), /*#__PURE__*/React.createElement(LinksWrapper, null));
};

/**
 @deprecated Use colors and styles from brand theme.
*/
var colors$1 = {
  black: '#000',
  bluemine: '#1B556F',
  celery: '#A8C045',
  chinchilla: '#7F7F7F',
  darkgray: '#7F7F7F',
  flamepea: '#D04328',
  gray: '#CCC',
  lightgray: '#E2E2E2',
  graySuit: '#EAE8ED',
  lochmara: '#007DC6',
  tangerine: '#FBAD19',
  primary: '#007DC6',
  secondary: '#E2E2E2',
  shakespeare: '#82BFE2',
  positive: '#00B860',
  negative: '#D04328',
  neutral: '#CCC',
  white: '#FFF'
};
var orderedColors = ['#007DC6', '#d03829', '#93b6b0', '#b6ad46', '#8f4f68', '#66bb83', '#5a80c4', '#465d39', '#d78e52', '#57c4c8'];
var breakpoints$1 = {
  xs: 0,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 4000
};
var theme$1 = {
  name: 'goodway',
  breakpoints: breakpoints$1,
  colors: colors$1,
  orderedColors: orderedColors,
  global: {
    colors: {
      border: colors$1.gray,
      background: colors$1.white
    },
    global: {
      colors: {
        border: colors$1.gray,
        background: colors$1.white,
        headerBarColor: colors$1.black,
        sideBarColor: colors$1.bluemine,
        highlightColor: colors$1.tangerine,
        buttonColor: colors$1.primary
      },
      constrastThresholdsFromWhite: {
        headerBarBorder: 2,
        sideBarBorder: 2
      },
      borders: {
        layout: '1px solid #ccc'
      },
      font: {
        primary: '\'Lato\', sans-serif'
      }
    }
  }
};

var HeaderContext = /*#__PURE__*/createContext();
var Header = function Header(_ref) {
  var parentTheme = _ref.parentTheme,
    isPartial = _ref.isPartial,
    user = _ref.user,
    styles = _ref.styles,
    doLogout = _ref.doLogout,
    logoHrefUrl = _ref.logoHrefUrl,
    closer = _ref.closer;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: function theme() {
      var headerTheme = parentTheme ? parentTheme.colors : theme$1.colors;
      return _objectSpread2(_objectSpread2({}, headerTheme), styles);
    }
  }, /*#__PURE__*/React.createElement(HeaderContext.Provider, {
    value: {
      user: user,
      doLogout: doLogout,
      logoHrefUrl: logoHrefUrl,
      closer: closer
    }
  }, isPartial ? /*#__PURE__*/React.createElement(LinksWrapper, null) : /*#__PURE__*/React.createElement(FullHeader, null)));
};
Header.propTypes = {
  /** Current User object */
  user: PropTypes.shape({
    /** Name of current User */
    fullName: PropTypes.string.isRequired,
    /** Email of current User */
    email: PropTypes.string.isRequired,
    /** Array of capabilities for current user */
    scope: PropTypes.array.isRequired
  }).isRequired,
  /** Styles from parent */
  styles: PropTypes.object,
  /** Styles for overriding default theme */
  parentTheme: PropTypes.object,
  /** Bool to determin full header rendering */
  isPartial: PropTypes.bool,
  /** Function to log out current User */
  doLogout: PropTypes.func.isRequired,
  /** Url for logo routing */
  logoHrefUrl: PropTypes.string,
  /** Ref that triggers menu closer */
  closer: PropTypes.elementType
};

var AnimatedHeart = styled('span')(function (_ref) {
  var animate = _ref.animate;
  return [{
    width: '50px',
    height: '50px',
    margin: '-18px -16px',
    background: 'url("data:image/png;base64,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") no-repeat',
    display: 'inline-block'
  }, animate && {
    backgroundPosition: '-1400px 1px',
    transition: 'background 1s steps(28)'
  }];
});
var GoodwayHeart = function GoodwayHeart() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    animate = _useState2[0],
    setAnimate = _useState2[1];
  return /*#__PURE__*/React.createElement(AnimatedHeart, {
    animate: animate,
    onClick: function onClick() {
      setAnimate(true);
      setTimeout(function () {
        return setAnimate(false);
      }, 1000);
    }
  });
};

var _templateObject$2;
var FooterContainer = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: -100px;\n    flex-direction: column;\n    background-color: #fff;\n    color: ", ";\n    border-top: solid 1px ", ";\n    width: 100%;\n    height: 100px;\n    padding: 16px 10px;\n    font-size: 14px;\n    font-family: Lato;\n    div {\n        padding-bottom: 4px;\n    }\n"])), function (_ref) {
  var _theme$colors;
  var theme = _ref.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : _theme$colors.darkgray) || '#7F7F7F';
}, function (_ref2) {
  var _theme$colors2;
  var theme = _ref2.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2.gray) || '#CCCCCC';
});
var Footer = function Footer(_ref3) {
  var theme = _ref3.theme,
    year = _ref3.year;
  return /*#__PURE__*/React.createElement(FooterContainer, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", null, "\xA9 ", year, " Goodway Group"), /*#__PURE__*/React.createElement("div", null, "Made with ", /*#__PURE__*/React.createElement(GoodwayHeart, null), " by Goodway Group Engineers."), /*#__PURE__*/React.createElement("div", null, "Powered by the Goodway Data Warehouse."));
};

var AuthContext = /*#__PURE__*/createContext({
  user: null,
  loading: true,
  error: null,
  preventLoginRedirect: false,
  loginUrl: null,
  appName: ''
});

var _templateObject$1;
var GET_USER_DATA = gql(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    query getUserData {\n        userData @rest(type: \"UserData\", path: \"/v1/users/me\", method: \"GET\") {\n            email\n            fullName\n            id\n            isOkta\n            landingPage\n            scope\n        }\n    }\n"])));
var ApolloAuthProvider = function ApolloAuthProvider(_ref) {
  var children = _ref.children,
    preventLoginRedirect = _ref.preventLoginRedirect,
    loginUrl = _ref.loginUrl,
    _ref$appName = _ref.appName,
    appName = _ref$appName === void 0 ? '' : _ref$appName;
  var _useQuery = useQuery(GET_USER_DATA),
    loading = _useQuery.loading,
    data = _useQuery.data,
    error = _useQuery.error;
  var userData = get(data, 'userData', null);
  return /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: {
      user: userData,
      loading: loading,
      error: error,
      preventLoginRedirect: preventLoginRedirect,
      loginUrl: loginUrl,
      appName: appName
    }
  }, children);
};
ApolloAuthProvider.propTypes = {
  children: PropTypes.any.isRequired,
  loginUrl: PropTypes.string.isRequired,
  preventLoginRedirect: PropTypes.bool,
  appName: PropTypes.string
};

var USER_LOGGED_OUT = '310';
var USER_UNAUTHORIZED = '401';

var statusCodes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  USER_LOGGED_OUT: USER_LOGGED_OUT,
  USER_UNAUTHORIZED: USER_UNAUTHORIZED
});

var cookie = {};

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */

cookie.parse = parse;
cookie.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0;
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index);

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index);

    if (endIdx === -1) {
      endIdx = str.length;
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1;
      continue
    }

    var key = str.slice(index, eqIdx).trim();

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim();

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1);
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1;
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires;

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority;

    switch (priority) {
      case 'low':
        str += '; Priority=Low';
        break
      case 'medium':
        str += '; Priority=Medium';
        break
      case 'high':
        str += '; Priority=High';
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} str
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

/**
 * Function that returns auth token from local storage or cookies and sets
 * local auth token if not already set.
 * 
 * @returns {string} 
 */

var getAuthToken = function getAuthToken() {
  var cookieAuthToken = cookie.parse(document.cookie).authToken;
  var authToken = localStorage.getItem("authToken");
  if (!authToken && cookieAuthToken) {
    authToken = cookieAuthToken;
    localStorage.setItem('authToken', authToken);
  }
  return authToken;
};

/**
 * Clear local storage and remove auth token cookie. 
 */

var clearLocalStorage = function clearLocalStorage() {
  localStorage.clear();
  document.cookie = 'authToken=;path=/;domain=goodwaygroup.com;expires=Thu, 01 Jan 1999 00:00:00 GMT';
};

var navigateToLogin = function navigateToLogin(loginUrl) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : USER_UNAUTHORIZED;
  var appName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var from = appName ? encodeURIComponent("/".concat(appName)) : encodeURIComponent(window.location.pathname);
  window.location.replace(loginUrl.replace('{from}', from).replace('{status}', status));
};
var AuthRedirect = function AuthRedirect() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$status = props.status,
    status = _props$status === void 0 ? USER_UNAUTHORIZED : _props$status;
  var _useContext = useContext(AuthContext),
    preventLoginRedirect = _useContext.preventLoginRedirect,
    loginUrl = _useContext.loginUrl,
    appName = _useContext.appName;
  if (preventLoginRedirect) {
    // NOTE: This should only be reached in development environments
    clearLocalStorage();
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "DEVELOPER MODE"), /*#__PURE__*/React.createElement("h3", null, "Please reload the page and set your authToken"), /*#__PURE__*/React.createElement("p", null, "The previous authToken has been cleared. It was either expired or malformed."));
  }
  navigateToLogin(loginUrl, status, appName);
  return null;
};
AuthRedirect.propTypes = {
  redirectTo: PropTypes.string,
  status: PropTypes.string,
  appName: PropTypes.string
};
AuthRedirect.defaultProps = {
  status: USER_UNAUTHORIZED
};

var _templateObject, _templateObject2;
var fadeIn = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n"])));
var StyledLoading = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    animation: 5s ", " ease-in;\n"])), fadeIn);
var Loading = function Loading() {
  return /*#__PURE__*/React.createElement(StyledLoading, null, "Loading...");
};

var windowRedirect = function windowRedirect() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  window.location.href = href;
  return null;
};
var ProtectedApp = function ProtectedApp(_ref) {
  var capability = _ref.capability,
    render = _ref.render,
    _ref$redirect = _ref.redirect,
    redirect = _ref$redirect === void 0 ? windowRedirect : _ref$redirect;
  var _useContext = useContext(AuthContext),
    loading = _useContext.loading,
    user = _useContext.user,
    error = _useContext.error;

  // On all errors, redirect to the root of the app.
  if (error) {
    if (get(error, 'networkError.statusCode') === 401) {
      return /*#__PURE__*/React.createElement(AuthRedirect, null);
    }
    console.error(error);
    redirect("/");
    return null;
  }
  if (loading) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }

  // If a User does not have the required Capability, redirect to their landing page
  if (capability && !get(user, 'scope', []).includes(capability)) {
    redirect(user.landingPage || "/");
    return null;
  }
  return render(user);
};
ProtectedApp.propTypes = {
  capability: PropTypes.string.isRequired,
  render: PropTypes.func
};

var colors = {
  midnightBlue: {
    100: {
      hex: '#B8BDD9',
      rgb: '184, 189, 217',
      cmyk: '15, 13, 0, 15'
    },
    200: {
      hex: '#727AB2',
      rgb: '114, 122, 178',
      cmyk: '36, 31, 0, 30'
    },
    400: {
      hex: '#404877',
      rgb: '64, 72, 119',
      cmyk: '46, 39, 0, 53'
    },
    600: {
      hex: '#292E42',
      rgb: '41, 46, 66',
      cmyk: '38, 30, 0, 74'
    },
    900: {
      hex: '#1A1D31',
      rgb: '26, 29, 49',
      cmyk: '87, 80, 51, 63'
    }
  },
  goodwayBlue: {
    50: {
      hex: '#ECF4F9',
      rgb: '236, 244, 249',
      cmyk: '5, 2, 0, 2'
    },
    200: {
      hex: '#81BFDC',
      rgb: '129, 191, 220',
      cmyk: '41, 13, 0, 14'
    },
    400: {
      hex: '#007DC6',
      rgb: '0, 125, 198',
      cmyk: '84, 44, 0, 0'
    },
    600: {
      hex: '#0B3446',
      rgb: '11, 52, 70',
      cmyk: '84, 26, 000, 073'
    }
  },
  sun: {
    50: {
      hex: '#FDFBED',
      rgb: '253, 251, 237',
      cmyk: '0, 1, 6, 1'
    },
    100: {
      hex: '#FFF7E4',
      rgb: '255, 247, 228',
      cmyk: '0, 3, 11, 0'
    },
    200: {
      hex: '#FFE623',
      rgb: '255, 230, 35',
      cmyk: '0, 20, 86, 0'
    },
    400: {
      hex: '#FCD119',
      rgb: '252, 209, 25',
      cmyk: '2, 16, 96, 0'
    },
    600: {
      hex: '#FBAD19',
      rgb: '251, 173, 25',
      cmyk: '0, 31, 90, 2'
    },
    800: {
      hex: '#FFB815',
      rgb: '255, 184, 18',
      cmyk: '0, 28, 93, 0'
    }
  },
  sand: {
    100: {
      hex: '#F1F1F1',
      rgb: '241, 241, 241',
      cmyk: '4, 3, 3, 0'
    },
    200: {
      hex: '#C1C1C1',
      rgb: '193, 193, 193',
      cmyk: '4, 3, 3, 24'
    },
    300: {
      hex: '#A9A9A9',
      rgb: '169, 169, 169',
      cmyk: '4, 3, 3, 34'
    },
    400: {
      hex: '#919191',
      rgb: '145, 145, 145',
      cmyk: '4, 3, 3, 43'
    },
    500: {
      hex: '#797979',
      rgb: '121, 121, 121',
      cmyk: '4, 3, 3, 53'
    },
    600: {
      hex: '#606060',
      rgb: '96, 96, 96',
      cmyk: '4, 3, 3, 62'
    },
    700: {
      hex: '#484848',
      rgb: '72, 72, 72',
      cmyk: '4, 3, 3, 72'
    }
  },
  red: {
    50: {
      hex: '#F9EDEC',
      rgb: '249, 237, 236',
      cmyk: '0, 5, 5, 2'
    },
    400: {
      hex: '#C81420',
      rgb: '200, 20, 32',
      cmyk: '0, 71, 66, 21'
    },
    600: {
      hex: '#5E040A',
      rgb: '94, 4, 10',
      cmyk: '0, 35, 33, 63'
    }
  },
  black: {
    hex: '#000000',
    rgb: '0, 0, 0',
    cmyk: '0, 0, 0, 100'
  },
  white: {
    hex: '#FFFFFF',
    rgb: '255, 255, 255',
    cmyk: '0, 0, 0, 0'
  }
};
var lightAlertColors = {
  default: {
    textColor: "rgba(".concat(colors.black.rgb, ", .8)"),
    backgroundColor: colors.sand[100].hex,
    iconColor: colors.sand[400].hex,
    buttonHoverColor: colors.sand[600].hex
  },
  error: {
    textColor: "rgba(".concat(colors.black.rgb, ", .8)"),
    backgroundColor: colors.red[50].hex,
    iconColor: colors.red[400].hex,
    buttonHoverColor: colors.red[600].hex
  },
  warning: {
    textColor: "rgba(".concat(colors.black.rgb, ", .8)"),
    backgroundColor: colors.sun[100].hex,
    iconColor: colors.sun[600].hex,
    buttonHoverColor: colors.sun[800].hex
  },
  info: {
    textColor: "rgba(".concat(colors.black.rgb, ", .8)"),
    backgroundColor: colors.sun[50].hex,
    iconColor: colors.sun[400].hex,
    buttonHoverColor: colors.sun[600].hex
  },
  success: {
    textColor: "rgba(".concat(colors.black.rgb, ", .8)"),
    backgroundColor: colors.goodwayBlue[50].hex,
    iconColor: colors.goodwayBlue[400].hex,
    buttonHoverColor: colors.goodwayBlue[600].hex
  }
};
({
  default: {
    textColor: "rgba(".concat(colors.white.rgb, ", .8)"),
    backgroundColor: colors.sand[400].hex,
    iconColor: "rgba(".concat(colors.white.rgb, ", 0.75)"),
    buttonHoverColor: colors.sand[100].hex
  },
  error: {
    textColor: "rgba(".concat(colors.white.rgb, ", .8)"),
    backgroundColor: colors.white.hex,
    iconColor: "rgba(".concat(colors.white.rgb, ", 0.75)"),
    buttonHoverColor: colors.red[400].hex
  },
  warning: {
    textColor: "rgba(".concat(colors.white.rgb, ", .8)"),
    backgroundColor: colors.sun[600].hex,
    iconColor: "rgba(".concat(colors.white.rgb, ", 0.75)"),
    buttonHoverColor: colors.sun[100].hex
  },
  info: {
    textColor: "rgba(".concat(colors.white.rgb, ", .8)"),
    backgroundColor: colors.sun[400].hex,
    iconColor: "rgba(".concat(colors.white.rgb, ", 0.75)"),
    buttonHoverColor: colors.sun[600].hex
  },
  success: {
    textColor: "rgba(".concat(colors.white.rgb, ", .8)"),
    backgroundColor: colors.goodwayBlue[400].hex,
    iconColor: "rgba(".concat(colors.white.rgb, ", 0.75)"),
    buttonHoverColor: colors.goodwayBlue[50].hex
  }
});

var typography = {
  fontFamilySummary: ['Lato', 'Helvetica', 'sans-serif'].join(','),
  pageHeader: {
    size: '3rem',
    lineHeight: 1.167,
    fontWeight: 400,
    muiCode: 'h3'
  },
  mediumHeader: {
    size: '1.5rem',
    lineHeight: 1.334,
    fontWeight: 400,
    muiCode: 'h5'
  },
  smallHeader: {
    size: '1.25rem',
    lineHeight: 1.6,
    fontWeight: 500,
    muiCode: 'h6'
  },
  body1: {
    size: '1rem',
    lineHeight: 1.5,
    fontWeight: 400,
    muiCode: 'body1'
  },
  body2: {
    size: '0.875rem',
    lineHeight: 1.43,
    fontWeight: 400,
    fontStyle: 'italic',
    muiCode: null
  },
  caption: {
    size: '0.75rem',
    lineHeight: 1.66,
    fontWeight: 400,
    muiCode: 'caption'
  },
  button: {
    size: '0.875rem',
    lineHeight: 1.75,
    fontWeight: 500,
    fontStyle: 'bold',
    muiCode: null
  }
};
var muiTypography = {
  fontFamilySummary: typography.fontFamilySummary
};

var breakpoints = {
  xs: 0,
  sm: 576,
  md: 768
};
var lightTheme = {
  palette: {
    colors: colors,
    primary: {
      light: colors.goodwayBlue[200].hex,
      main: colors.goodwayBlue[400].hex,
      dark: colors.goodwayBlue[600].hex
    },
    secondary: {
      light: colors.sun[200].hex,
      main: colors.sun[400].hex,
      dark: colors.sun[600].hex
    },
    alertColors: lightAlertColors,
    text: {
      primary: colors.midnightBlue[900].hex,
      secondary: colors.sand[600].hex
    }
  },
  elements: {
    button: {
      padding: '5px 15px',
      borderRadius: '4px',
      default: {
        default: {
          color: colors.goodwayBlue[400].hex,
          backgroundColor: null,
          border: "1px solid rgba(".concat(colors.goodwayBlue[400].rgb, ", 0.5)")
        },
        hover: {
          color: colors.goodwayBlue[600].hex,
          backgroundColor: "rgba(".concat(colors.goodwayBlue[400].rgb, ", 0.04)"),
          border: "1px solid rgba(".concat(colors.goodwayBlue[400].rgb, ", 1)")
        },
        disabled: {
          color: "rgba(".concat(colors.sand[700].rgb, ", 0.26)"),
          backgroundColor: null,
          border: "1px solid rgba(".concat(colors.sand[500].rgb, ", 0.12)")
        }
      },
      primary: {
        default: {
          color: colors.black.hex,
          backgroundColor: colors.goodwayBlue[400].hex
        },
        hover: {
          color: colors.black.hex,
          backgroundColor: colors.goodwayBlue[600].hex
        },
        disabled: {
          color: "rgba(".concat(colors.sand[700].rgb, ", 0.26)"),
          backgroundColor: "rgba(".concat(colors.sand[500].rgb, ", 0.12)")
        }
      },
      subtle: {
        default: {
          color: colors.goodwayBlue[400].hex,
          backgroundColor: null
        },
        hover: {
          color: colors.goodwayBlue[400].hex,
          backgroundColor: "rgba(".concat(colors.goodwayBlue[400].rgb, ", 0.04)")
        },
        disabled: {
          color: "rgba(".concat(colors.sand[700].rgb, ", 0.26)"),
          backgroundColor: null
        }
      }
    },
    modal: {
      overlayColor: "rgba(".concat(colors.black.rgb, ", 0.5)"),
      backgroundColor: colors.white.hex,
      borderRadius: '0px',
      modalHeader: muiTypography.mediumHeader
    },
    leftNav: {
      backgroundColor: colors.goodwayBlue[600].hex,
      color: colors.sand[100].hex,
      hoverColor: colors.sun[400].hex,
      width: '200px'
    },
    toast: {
      colors: lightAlertColors,
      color: "rgba(".concat(colors.black.rgb, ", 0.75)"),
      padding: '6px 16px',
      positon: 'fixed',
      left: '24px',
      bottom: '24px'
    }
  }
};
var darkTheme = {};
var theme = {
  light: _objectSpread2(_objectSpread2({}, lightTheme), {}, {
    typography: muiTypography,
    breakpoints: breakpoints
  }),
  dark: _objectSpread2(_objectSpread2({}, darkTheme), {}, {
    typography: muiTypography,
    breakpoints: breakpoints
  })
};

var GoodwayTheme = theme;

var muiBreakpoints = createBreakpoints(breakpoints);
var muiLightTheme = {
  palette: {
    primary: lightTheme.palette.primary,
    secondary: lightTheme.palette.secondary,
    error: {
      main: lightAlertColors.error.iconColor
    },
    warning: {
      main: lightAlertColors.warning.iconColor
    },
    info: {
      main: lightAlertColors.info.iconColor
    },
    success: {
      main: lightAlertColors.success.iconColor
    },
    background: {
      main: colors.white.hex
    },
    text: {
      primary: colors.midnightBlue[400].hex,
      secondary: colors.sand[700].hex
    },
    others: _objectSpread2({}, colors)
  }
};
var muiDarkTheme = {
  palette: {
    primary: darkTheme.primary,
    secondary: darkTheme.secondary
  }
};
var muiTheme = {
  light: _objectSpread2(_objectSpread2({}, muiLightTheme), {}, {
    typography: muiTypography,
    breakpoints: muiBreakpoints
  }),
  dark: _objectSpread2(_objectSpread2({}, muiDarkTheme), {}, {
    typography: muiTypography,
    breakpoints: muiBreakpoints
  })
};

var muiOverrides = {
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        '& .MuiAutocomplete-endAdornment': {
          top: 'auto'
        }
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'unset !important'
      },
      startIcon: {
        marginRight: 2
      },
      outlined: {
        backgroundColor: colors.white.hex
      }
    }
  },
  MuiContainer: {
    styleOverrides: {
      root: _defineProperty({}, muiBreakpoints.up('xl'), {
        maxWidth: '90%'
      })
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        height: '2.5rem',
        width: '2.5rem'
      }
    }
  },
  MuiAlert: {
    styleOverrides: {
      icon: {
        alignItems: 'center'
      },
      action: {
        padding: '0 0 0 16px'
      }
    }
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        backgroundColor: colors.white.hex
      }
    }
  }
};

var MuiGoodwayTheme = _objectSpread2(_objectSpread2({}, muiTheme.light), {}, {
  components: muiOverrides
});

var AuthDefault = function AuthDefault() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    promptForMissingAuthToken: false
  };
  var authToken = getAuthToken();
  var email;
  var loggedIn;
  if (options.bypassGraphAuth) {
    email = options.bypassEmail || 'someone@goodwaygroup.com';
    loggedIn = true;
    authToken = 'fakeToken';
  } else {
    var shouldPromptAuthToken = options.promptForMissingAuthToken && !authToken;
    if (shouldPromptAuthToken) {
      // eslint-disable-next-line no-alert  -- Prompt is only for dev
      var inputToken = window.prompt('Please enter authToken:');
      localStorage.setItem('authToken', inputToken);
      authToken = inputToken;
    }
    try {
      var decodedToken = jwt_decode(authToken);
      email = decodedToken.userEmail;
      if (!authToken) {
        email = null;
        loggedIn = false;
      } else {
        loggedIn = true;
      }
    } catch (error) {
      email = null;
      loggedIn = false;
    }
  }
  return {
    User: {
      __typename: 'User',
      isLogged: loggedIn,
      email: email,
      authToken: authToken
    }
  };
};

var nullClient = function nullClient() {};
var HTTP_UNAUTHORIZED = 401;
var loginAfterAuthError = function loginAfterAuthError(loginUrl) {
  var preventLoginRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var getClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : nullClient;
  var appName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var doLogin = function doLogin() {
    clearLocalStorage();
    if (!preventLoginRedirect) {
      navigateToLogin(loginUrl, USER_UNAUTHORIZED, appName);
    }
  };
  return onError(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
      networkError = _ref.networkError;
    var client = getClient();
    if (graphQLErrors && graphQLErrors.filter(function (e) {
      return e;
    }).length > 0) {
      var _iterator = _createForOfIteratorHelper(graphQLErrors.filter(function (e) {
          return e;
        })),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var status = _step.value.status;
          if (status === HTTP_UNAUTHORIZED) {
            if (client) {
              client.clearStore().then(doLogin);
            } else {
              doLogin();
            }
          } else {
            console.error(graphQLErrors);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (networkError && networkError.statusCode === HTTP_UNAUTHORIZED) {
      if (client) {
        client.clearStore().then(doLogin);
      } else {
        doLogin();
      }
    }
  });
};

/**
 * @deprecated Use loginAfterAuthError
 */
var goLogin = function goLogin() {
  localStorage.clear();
  // Grab url from env or default to prod.
  var loginUrl = get(window, 'goodway.REACT_APP_LOGIN_API_URL');
  navigateToLogin(loginUrl || get(process, 'env.REACT_APP_LOGIN_API_URL', 'https://portal.goodwaygroup.com/login?status={status}&from={from}'));
};
/**
 * @deprecated Use loginAfterAuthError
 */
var loginOnUnauthorizedError = function loginOnUnauthorizedError() {
  var getClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : nullClient;
  return onError(function (_ref2) {
    var graphQLErrors = _ref2.graphQLErrors,
      networkError = _ref2.networkError;
    var client = getClient();
    if (graphQLErrors && graphQLErrors.filter(function (e) {
      return e;
    }).length > 0) {
      var _iterator2 = _createForOfIteratorHelper(graphQLErrors.filter(function (e) {
          return e;
        })),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var status = _step2.value.status;
          if (status === HTTP_UNAUTHORIZED) {
            if (client) {
              client.clearStore().then(goLogin);
            } else {
              goLogin();
            }
          } else {
            console.error(graphQLErrors);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    if (networkError && networkError.statusCode === HTTP_UNAUTHORIZED) {
      if (client) {
        client.clearStore().then(goLogin);
      } else {
        goLogin();
      }
    }
  });
};
var withAuthToken = setContext(function () {
  var authToken = getAuthToken();
  return {
    headers: {
      authorization: authToken ? "Bearer ".concat(authToken) : ""
    }
  };
});
var g90LoginLink = function g90LoginLink(loginApiUrl) {
  return withAuthToken.concat(new RestLink({
    uri: loginApiUrl
  }));
};
var appLink = function appLink(appApiUrl) {
  return withAuthToken.concat(new HttpLink({
    uri: appApiUrl
  }));
};

export { ApolloAuthProvider, AuthContext, AuthDefault, AuthRedirect, Footer, GoodwayTheme, Header, MuiGoodwayTheme, ProtectedApp, statusCodes as StatusCodes, appLink, g90LoginLink, loginAfterAuthError, loginOnUnauthorizedError, navigateToLogin, withAuthToken };
//# sourceMappingURL=index.es.js.map
